module.exports = __webpack_public_path__ + "static/img/img11.5ad530b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/126/img11.jpg
// module id = 35cd
// module chunks = 0